export const APP_URL = "https://aladdinshenewa.online";
export const BUSINESS_NAME = "Aladdin Shenewa";
export const BRAND = {
  background: "#F7F1E8",
  accent: "#F08A24",
  text: "#2B2B2B",
  card: "#FFFFFF"
} as const;

export const CONTACT_EMAIL = "aladdinshenewa@outlook.com";
export const CONTACT_PHONE = "832-450-9444";
export const CONTACT_PHONE_TEL = "+18324509444";

export const navigation = [
  { label: "Home", href: "/" },
  { label: "Portfolio", href: "/portfolio" },
  { label: "About", href: "/about" },
  { label: "Build", href: "/contact" }
] as const;

export const footerNavigation = [
  { label: "Services", href: "/services" },
  { label: "Pricing", href: "/pricing" },
  { label: "Blog", href: "/blog" },
  { label: "FAQ", href: "/faq" },
  { label: "Contact", href: "/contact" }
] as const;
